import { render } from "./SmsConfigBoard.vue?vue&type=template&id=36a21a88"
import script from "./SmsConfigBoard.vue?vue&type=script&lang=js"
export * from "./SmsConfigBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__